module.exports = __webpack_public_path__ + "img/lg_ring_g_i_0_1.5405bde2.png";